export default function Mission() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h2 className="text-5xl font-bold text-orange-500">Our Mission</h2>
            <p className="text-gray-700 text-base leading-relaxed">
              Our Mission is to provide clients quality one-on-one care at all times. We follow a client-centered
              approach through which we strive to deliver personalized care to you according to your needs. Get your
              care provider today at the best rates possible. Let us serve you!
            </p>
          </div>

          <div className="space-y-8">
            <div className="text-center">
              <h2 className="text-4xl font-bold text-[#5C4F8A] mb-8">How We Care</h2>
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div className="flex justify-center items-center">
                <img
                  src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/8b02cbb2fdf9642cec399bcd5abe0eac.jpeg"
                  alt="Employer of Choice 2026"
                  className="w-full max-w-[160px] h-auto object-contain"
                />
              </div>
              <div className="flex justify-center items-center">
                <img
                  src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/c1d03d1e32396a31eab4f81e73386082.png"
                  alt="Best of Home Care - Top 100 in Experience 2026"
                  className="w-full max-w-[160px] h-auto object-contain"
                />
              </div>
              <div className="flex justify-center items-center">
                <img
                  src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/161d814b9faecd60d27f00ff02eed387.png"
                  alt="HCP Experience Management"
                  className="w-full max-w-[160px] h-auto object-contain"
                />
              </div>
            </div>

            <div className="text-center space-y-6 bg-gray-50 p-8 rounded-2xl">
              <h3 className="text-xl font-semibold text-gray-900 leading-relaxed">
                Recognized as one of the <span className="text-orange-500 font-bold">Best of Homecare</span>. We have
                been Awarded Provider of Choice for being one of the top home care providers in the nation.
              </h3>
              <a
                href="#contact"
                className="inline-block bg-[#5C4F8A] text-white px-8 py-3 rounded-lg hover:bg-[#4A3D72] transition-all duration-300 text-sm font-medium whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
